const filters = {
  toFixSecond: function(value) {
    if (!value) return "";
    return parseFloat(value).toFixed(2);
  }
};
export default vm => {
  Object.keys(filters).forEach(key => {
    vm.filter(key, filters[key]);
  });
};



// WEBPACK FOOTER //
// ./src/common/js/filter.js